import clsx from 'clsx'
import { Button } from '../Button'

export type ButtonGroupProps = {
  title?: string
  options: {
    value?: string
    label?: string
  }[]
  value?: string
  onButtonClick: (value?: string) => void
}

export function ButtonGroup (props: ButtonGroupProps) {
  const { title, options, value, onButtonClick } = props
  return (
    <div className='flex flex-col gap-1 '>
      {title && <h2 className="font-medium textarea-md text-gray-500">{title}</h2>}
      <div className='inline-block text-nowrap'>
        {options.map((option, i) => (
          <Button
            key={option.value}
            disabled={value === option.value}
            onClick={() => onButtonClick(option?.value)}
            className={clsx(
              'rounded-none bg-base-100 font-medium py-1.5 h-auto disabled:text-base-content',
              i === 0 && 'rounded-tl-lg rounded-bl-lg',
              i === options.length - 1 && 'rounded-tr-lg rounded-br-lg'
            )}
          >
            {option?.label}
          </Button>
        ))}
      </div>
    </div>
  )
}
